import * as Actions    from './actions';
import * as Selectors  from './selectors';
import { compose }     from 'redux';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';


// Contacts Hooks

// Selectors

export function useContacts(businessID) {
  return useSelector(state => Selectors.getContacts(state, businessID));
}

export function useEmailContacts(businessID) {
  return useSelector(state => Selectors.getEmailContacts(state, businessID));
}

export function useContactsStatuses(businessID) {
  return useSelector(state => Selectors.getContactsStatuses(state, businessID));
}


// Actions

export function useReadContacts(businessID) {
  return compose(useDispatch(), Actions.readContacts, () => businessID);
}
